import { render } from "./ModalManagerLogout.vue?vue&type=template&id=18e43d46"
import script from "./ModalManagerLogout.vue?vue&type=script&lang=js"
export * from "./ModalManagerLogout.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__